import { Badge } from '@capawesome/capacitor-badge';
import { Capacitor } from '@capacitor/core';

class BadgeService {
  async setCount(count: number): Promise<void> {
    const safeCount = Math.max(0, Math.trunc(count || 0));

    try {
      if (Capacitor.isNativePlatform()) {
        const { isSupported } = await Badge.isSupported();
        if (!isSupported) return;

        if (safeCount > 0) {
          await Badge.set({ count: safeCount });
        } else {
          await Badge.clear();
        }
        return;
      }

      if (typeof navigator !== 'undefined' && 'setAppBadge' in navigator) {
        if (safeCount > 0) {
          await (navigator as any).setAppBadge(safeCount);
        } else if ('clearAppBadge' in navigator) {
          await (navigator as any).clearAppBadge();
        }
      }
    } catch (error) {
      console.error('❌ Failed to update app badge:', error);
    }
  }

  async clear(): Promise<void> {
    if (Capacitor.isNativePlatform() && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('blissnet-badge-force-clear'));
      return;
    }
    await this.setCount(0);
  }
}

export const badgeService = new BadgeService();
